import styled from "styled-components";
import { theme } from "../../../../../helpers/theme";
import SessionService from "../../../../../services/session-service";

interface OfferFormHeaderProps {
  continueOrder: boolean;
}

const OfferFormHeader = ({ continueOrder }: OfferFormHeaderProps) => {
  return (
    <HeadersWrapper>
      <MainHeader>{`${
        continueOrder ? "Dokończ Wypełnianie formularza" : "Wypełnij formularz"
      } `}</MainHeader>
      <SubHeader>
        I odbierz{` `}
        <SubHeaderBold>najlepszą ofertę</SubHeaderBold>
        {` `}Na magazynowanie
      </SubHeader>
    </HeadersWrapper>
  );
};

export default OfferFormHeader;

const HeadersWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const MainHeader = styled.h2`
  font-family: ${theme.fonts.interBold};
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 40px;
  margin-top: 0;
  margin-bottom: 10px;
`;
const SubHeader = styled.span`
  font-family: ${theme.fonts.interMedium};
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 10px;
`;
const SubHeaderBold = styled.span`
  font-weight: bold;
`;
